/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import kafkaLogo from '@/assets/kafka.svg'
import eventHubLogo from '@/assets/msft/azure-event-hub.svg'
import kinesisLogo from '@/assets/aws/aws-kinesis.svg'
import pubsubLogo from '@/assets/gcp/PubSub.svg'

const handleStyleLeft = { left: -2, top: 44 }

function StreamingNode({ data, isConnectable }) {
  const plcLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    if (demoEnv === 'MSFT') {
      return eventHubLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return kinesisLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return pubsubLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return kafkaLogo
    }
  }
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} style={handleStyleLeft} />

      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={plcLogo()} alt="PLC Logo" className="custom-node-plc-icon" />
          </div>
          <div className="text-center">
            <b>Streaming</b>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StreamingNode
